export default "__VITE_PUBLIC_ASSET__fbf0dc79__"